export type IDexBuySellBotDirection = 'buy' | 'sell';
export type IDexBuySellBotTypeUnit = '1w-ns' | '1w-1s';
export type IDexBuySellBotOptsUnit = 'opts_type_1w-ns' | 'opts_type_1w-1s';

export type IBuySellTaskStatus = 'current' | 'past' | 'future';

export const EnumDexBuySellType = {
  TYPE_1W_NS: '1w-ns',
  TYPE_1W_1S: '1w-1s',
} as const;

export const EnumDexBuySellOpts = {
  OPT_TYPE_1W_NS: 'opts_type_1w-ns',
  OPT_TYPE_1W_1S: 'opts_type_1w-1s',
} as const;

export interface IDexBuySellBotOptsType1wNs {
  enabled: boolean;
  stop_on_external_same_side?: boolean;
  start_time: string;
  direction: IDexBuySellBotDirection;
  use_mempool: 'on' | 'off' | 'only';
  price_threshold: {
    max: string;
    min: string;
    currency_base: string;
    currency_quote: string;
  };
  total_token_amount: {
    value: string;
    currency: string;
  };
  min_pause: string;
  max_pause: string;
  trade_amount_range: {
    min_value: string;
    max_value: string;
    currency: string;
  };
  advance_coefficient: number;
  amount_disperse_coeff_max: number;
  amount_disperse_coeff_min: number;
  skip_transactions_max: number;
  skip_transactions_min: number;
}

export interface IDexBuySellBotOptsType1w1s {
  enabled: boolean;
  stop_on_external_same_side?: boolean;
  start_time: string;
  direction: IDexBuySellBotDirection;
  price_threshold: {
    max: string;
    min: string;
    currency_base: string;
    currency_quote: string;
  };
  min_pause: string;
  max_pause: string;
  trade_amount_range: {
    min_value: string;
    max_value: string;
    currency: string;
  };
  advance_coefficient: number;
}

export interface IDexBuySellBotTask {
  id: number;
  pair_id: number;
  type: IDexBuySellBotTypeUnit;
  [EnumDexBuySellOpts.OPT_TYPE_1W_NS]: IDexBuySellBotOptsType1wNs;
  [EnumDexBuySellOpts.OPT_TYPE_1W_1S]: IDexBuySellBotOptsType1w1s;
  is_active: boolean;
  volume: string;
  transactions_count: number;
  external_stop_latched?: boolean;
  external_stop?: {
    side: 'buy' | 'sell';
    tx_hash: string;
    block_number: number;
    transaction_index: number;
    log_index: number;
    stopped_at: string;
  };
  wallets_total: number;
  wallets_without_tx: number;
  created_at: string;
  updated_at: string;
}

export interface IDexBuySellBotTaskItem {
  task: IDexBuySellBotTask;
  is_current: true;
  total: {
    amount: string;
    amount_usd: string;
    progress_percent: string;
    quote_amount: string;
    quote_amount_usd: string;
    avg_price: string;
    avg_price_usd: string;
    spent_fee: string;
    spent_fee_usd: string;
    transactions_count: number;
  };
  schedule: {
    amount: string;
    amount_usd: string;
    quote_amount: string;
    quote_amount_usd: string;
    progress_percent: string;
    avg_price: string;
    avg_price_usd: string;
    spent_fee: string;
    spent_fee_usd: string;
    transactions_count: number;
  };
  mempool: {
    amount: string;
    amount_usd: string;
    progress_percent: string;
    quote_amount: string;
    quote_amount_usd: string;
    avg_price: string;
    avg_price_usd: string;
    spent_fee: string;
    spent_fee_usd: string;
    transactions_count: number;
  };
  time_left_sec: number;
}

export type IBuySellBotTaskItemInner = IDexBuySellBotTaskItem & {
  status: IBuySellTaskStatus;
};

export interface IDexBuySellBotConfig {
  is_enabled: boolean;
  send_private_transactions: boolean;
  slippage_percent: string;
  reserve_wallets_priority: 'default' | 'random';
}

export interface IDexBuySellBotWallet {
  id: number;
  index: number;
  address: string;
  is_disabled: boolean;
  tokens: any[];
  connected_bots: any[];
  projects: any[];
  task_volume: string;
  task_transactions_count: number;
}
